import React, { useState, useEffect, useRef } from 'react';
import './LocationSelect.css';

export default function LocationSelect({ locations, value, onChange, multiple = false }) {
  const [search, setSearch] = useState('');
  const [open,   setOpen]   = useState(false);
  const ref = useRef();

  const filtered = locations.filter(l =>
    l.name.toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    function onClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  const selectedList = multiple ? (value || []) : [];
  const isSelected    = l => multiple
    ? selectedList.some(s => s.id === l.id)
    : value?.id === l.id;

  function pick(l) {
    if (!multiple) {
      onChange(l);
      setOpen(false);
      setSearch('');
      return;
    }
    const next = isSelected(l)
      ? selectedList.filter(s => s.id !== l.id)
      : [...selectedList, l];
    onChange(next);
  }

  let triggerLabel;
  if (multiple) {
    triggerLabel = selectedList.length === 0
      ? 'Select locations…'
      : selectedList.length === 1
        ? selectedList[0].name
        : `${selectedList.length} locations selected`;
  } else {
    triggerLabel = value ? value.name : 'Select location…';
  }
  const hasSelection = multiple ? selectedList.length > 0 : !!value;

  return (
    <div className="pk-loc-select" ref={ref}>
      <div
        className={`pk-loc-trigger ${open ? 'open' : ''}`}
        onClick={() => setOpen(o => !o)}
      >
        <span className={hasSelection ? '' : 'pk-placeholder'}>
          {triggerLabel}
        </span>
        <span className="pk-loc-chevron">▾</span>
      </div>
      {open && (
        <div className="pk-loc-dropdown">
          <input
            className="pk-loc-search"
            placeholder="Search locations…"
            value={search}
            onChange={e => setSearch(e.target.value)}
            autoFocus
          />
          <div className="pk-loc-list">
            {filtered.length === 0
              ? <div className="pk-loc-empty">No locations found</div>
              : filtered.map(l => (
                <div
                  key={l.id}
                  className={`pk-loc-item ${isSelected(l) ? 'selected' : ''}`}
                  onClick={() => pick(l)}
                >
                  {multiple && (
                    <input
                      type="checkbox"
                      className="pk-loc-checkbox"
                      checked={isSelected(l)}
                      onChange={() => {}}
                    />
                  )}
                  {l.name}
                </div>
              ))
            }
          </div>
          {multiple && (
            <div className="pk-loc-footer">
              <button
                type="button"
                className="pk-loc-done"
                onClick={() => setOpen(false)}
              >
                Done{selectedList.length > 0 ? ` (${selectedList.length})` : ''}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
